export const getReferencePath = (): string => {
  try {
    return btoa(`${location.protocol}//${location.host}${location.pathname}`);
  } catch {
    return '';
  }
};

export const sanitizerChars = (query: string): string => {
  return query.replace(/[@&'(\\)<>#]/g, '');
};
